import React, { useEffect, useState } from "react";
import { admin } from "../../lib/api";

export default function EmailInbox() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    (async () => {
      const res = await admin.emails();
      setRows(res.rows);
    })();
  }, []);

  return (
    <div data-testid="emails-page">
      <div className="cw-eyebrow">Email Log (mocked)</div>
      <h1 className="cw-display-l" style={{ marginTop: 8 }}>Every send, captured.</h1>
      <p className="cw-body" style={{ marginTop: 8, color: "rgba(22,30,27,0.72)" }}>
        Real Resend delivery is deferred to a later stage. Meanwhile every code, report delivery,
        resume link, abandonment prompt, and 10-per-day digest is stored here for inspection.
      </p>

      <div className="cw-card" style={{ marginTop: 24, padding: 0, overflow: "hidden" }}>
        <table className="cw-table" data-testid="emails-table">
          <thead>
            <tr>
              <th>Sent</th>
              <th>To</th>
              <th>Sequence</th>
              <th>Subject</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`email-row-${r.id}`}>
                <td>{(r.sent_at || "").slice(0, 19).replace("T", " ")}</td>
                <td>{r.to_email}</td>
                <td><span className="pill pill-slate">{r.sequence}</span></td>
                <td>{r.subject}</td>
                <td>
                  <button
                    className="cw-btn-text"
                    onClick={() => setOpen(r)}
                    data-testid={`open-email-${r.id}`}
                  >Open</button>
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={5} style={{ textAlign: "center", color: "rgba(22,30,27,0.72)" }}>No emails yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {open && (
        <div
          style={{
            position: "fixed", inset: 0, background: "rgba(22,30,27,0.55)",
            zIndex: 60, display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
          }}
          onClick={() => setOpen(null)}
          data-testid="email-modal"
        >
          <div
            className="cw-card"
            style={{ background: "var(--cw-linen)", maxWidth: 720, width: "100%", maxHeight: "80vh", overflow: "auto" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="cw-eyebrow">{open.sequence}</div>
            <h2 className="cw-heading-m" style={{ marginTop: 8 }}>{open.subject}</h2>
            <p className="cw-small" style={{ marginTop: 8 }}>
              From: {open.from_email} · To: {open.to_email}
            </p>
            <pre style={{ marginTop: 16, whiteSpace: "pre-wrap", fontFamily: "var(--font-body)", fontSize: 14, lineHeight: 1.6 }}>
              {open.body_text}
            </pre>
            {open.attachments && open.attachments.length > 0 && (
              <p className="cw-small" style={{ marginTop: 12 }}>
                Attachments: {open.attachments.join(", ")}
              </p>
            )}
            <div style={{ marginTop: 20, textAlign: "right" }}>
              <button className="cw-btn light-primary" style={{ height: 40, padding: "0 20px" }} onClick={() => setOpen(null)} data-testid="close-email-modal">Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
